export default __webpack_public_path__ + "static/media/logo.901397c8.png";